
import {Component, Vue} from 'vue-property-decorator';
import {IExternalUser} from '@/interfaces/external_user';
import {rules, stringToNumber} from '@/utils';
import {dispatchRegisterExternalUser} from '@/store/main/actions';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import FileUpload from '@/components/forms/FileUpload.vue';

import {appName} from '@/env';

@Component({
  components: {FileUpload, DefaultHelp},
})
export default class ExternalUserRegister extends Vue {
  private externalUser: IExternalUser = {} as IExternalUser;
  private email2: string = '';
  private valid: boolean = true;
  private rules: any = rules;

  private appName = appName;

  public cancel() {
    this.$router.back();
  }

  public async save() {
    const form: any = this.$refs.form_crud_user;
    if (!form.validate()) {
      return;
    }

    const userToCreate = {
      ...this.externalUser,
      cpf: stringToNumber(this.externalUser.cpf),
    };

    const userCreated = await dispatchRegisterExternalUser(this.$store, userToCreate);
    if (userCreated) {
      await this.$router.push('/login');
    }
  }

  public changeDocument(val) {
    this.externalUser.document = val;
  }

  public changePersonalDocument(val) {
    this.externalUser.personal_document = val;
  }

}
